import { createSelector } from '@reduxjs/toolkit';

import { ExternalIntegrationDataSource } from 'dashboard/models/external-integration';
import { RootState } from 'dashboard/redux/store';
import { ExternalIntegrationDataSource as ApiModelExternalIntegrationDataSource } from 'lib/interfaces/api';

export const getExternalDataSources = createSelector(
  [(state: RootState) => state.externalIntegrations.externalIntegrations],
  (externalIntegrations) =>
    externalIntegrations.filter((e): e is ExternalIntegrationDataSource =>
      ApiModelExternalIntegrationDataSource.includes(e.type),
    ),
);
